module.exports = __webpack_public_path__ + "img/qrcodeimg.0ced184c.png";